import { RootState } from '../../../../config/store/rootReducer';

export const createIsPendingSelector = (action: string) => (state: RootState): boolean =>
  Boolean(state.loading[action] === undefined || state.loading[action]);

export const createActionRequestIsPendingSelector = (action: string) => (state: RootState): boolean =>
  Boolean(state.loading[action]);
